export default __webpack_public_path__ + "static/media/plus-blue.cfc7a5fd.svg";